import React, { useContext } from 'react';
import ScreenTextContext from '../contexts/ScreenTextContext';

export const Callout = ({children}) => {
  
  const { screenText } = useContext(ScreenTextContext);  
  
  if (!screenText || !screenText.global) {
    return "";
  }

  return (
    <div className="callout">
      <span className="callout__bg"></span>
      <span className="callout__border"></span>
      <span className="callout__highlight">{screenText.global.calloutHighlight}</span>
      <span className="callout__text">{children}</span>
    </div>
  )
}